import styled from "styled-components";

export const Flex = styled.div<{
  $alignItem?: string;
  $justifyContent?: string;
  $maxHeight?: boolean;
  $gap?: number;
  $flexGrow?: number;
  $width?: string;
}>`
  display: flex;
  height: ${(props) => props.$maxHeight && "100%"};
  align-items: ${(props) => props.$alignItem};
  justify-content: ${(props) => props.$justifyContent};
  gap: ${({ $gap }) => ($gap ? `${$gap}rem` : null)};
  width: ${({ $width }) => ($width ? $width : null)};
  flex-grow: ${({ $flexGrow }) => ($flexGrow ? $flexGrow : null)};
`;

export const Column = styled(Flex)`
  flex-direction: column;
  width: 100%;
`;

export const Row = styled(Flex)<{
  $flexWrap?: string;
}>`
  flex-direction: row;
  flex-wrap: ${(props) => props.$flexWrap ?? "unset"};
`;

export const Gap = styled.div<{
  $height: number;
}>`
  height: ${({ $height }) => $height}rem;
  flex-shrink: 0;
`;
